import React from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, HeartIcon, UsersIcon, SparklesIcon, ShieldIcon, SunIcon } from 'lucide-react';
export function MentalWellness() {
  const services = [{
    title: 'Trauma & PTSD Recovery',
    desc: 'Compassionate support for emotional healing and rebuilding resilience after difficult life experiences.',
    icon: ShieldIcon
  }, {
    title: 'Anxiety & Depression',
    desc: 'Evidence-based coaching to help manage mood disorders and rediscover joy and stability.',
    icon: SunIcon
  }, {
    title: 'Grief & Loss Support',
    desc: 'Navigating the journey of loss with empathy and professional guidance toward healing.',
    icon: HeartIcon
  }, {
    title: 'Youth & Adolescent Coaching',
    desc: 'Specialized support for younger generations navigating life transitions and emotional challenges.',
    icon: UsersIcon
  }, {
    title: 'Geriatric Mental Wellness',
    desc: 'Addressing the unique psychological needs of seniors, including loneliness and isolation support.',
    icon: SparklesIcon
  }, {
    title: 'Life Recovery & Purpose',
    desc: 'Discovering meaning and rebuilding a life driven by purpose and fulfillment.',
    icon: BrainIcon
  }];
  return <main className="bg-[#F5F2ED] min-h-screen" data-id="element-332">
      <section className="py-20 bg-[#1B4332] text-white" data-id="element-333">
        <div className="container mx-auto px-4 text-center" data-id="element-334">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl font-serif mb-6" data-id="element-335">
            Holistic Mental Wellness
          </motion.h1>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-336">
            Restoring emotional strength and renewing the mind through
            compassionate, trauma-informed coaching and support.
          </p>
        </div>
      </section>

      <section className="py-20" data-id="element-337">
        <div className="container mx-auto px-4" data-id="element-338">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-339">
            {services.map((service, idx) => <motion.div key={service.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: idx * 0.1
          }} className="bg-white p-8 rounded-3xl shadow-sm border border-[#1B4332]/5 hover:shadow-md transition-shadow" data-id="element-340">
                <div className="w-12 h-12 bg-[#1B4332]/10 rounded-2xl flex items-center justify-center text-[#1B4332] mb-6" data-id="element-341">
                  <service.icon size={24} data-id="element-342" />
                </div>
                <h3 className="text-xl font-bold text-[#1B4332] mb-4" data-id="element-343">
                  {service.title}
                </h3>
                <p className="text-[#1A374D]/70 leading-relaxed" data-id="element-344">
                  {service.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#E2E8E4]" data-id="element-345">
        <div className="container mx-auto px-4" data-id="element-346">
          <div className="max-w-4xl mx-auto bg-white rounded-3xl p-12 shadow-sm flex flex-col md:flex-row items-center gap-12" data-id="element-347">
            <div className="md:w-1/3" data-id="element-348">
              <div className="aspect-square rounded-2xl overflow-hidden" data-id="element-349">
                <img src="https://images.unsplash.com/photo-1594824476967-48c8b964273f?auto=format&fit=crop&q=80&w=400" alt="Mental Wellness Director" className="w-full h-full object-cover" data-id="element-350" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-351">
              <h2 className="text-3xl font-serif text-[#1B4332] mb-4" data-id="element-352">
                Expert Guidance
              </h2>
              <p className="text-[#1A374D]/80 mb-6 leading-relaxed" data-id="element-353">
                Led by our Mental Wellness Director, a Board-Certified Master
                Mental Health Coach with over 13 years of leadership and
                strategic development expertise.
              </p>
              <button className="px-8 py-3 bg-[#1B4332] text-white font-bold rounded-full hover:bg-[#143326] transition-all" data-id="element-354">
                Schedule a Session
              </button>
            </div>
          </div>
        </div>
      </section>
    </main>;
}